import { Injectable } from '@angular/core';
import { LocalStoreManagerService } from '../local-store-manager-service/local-store-manager.service';
import { v4 as uuidv4 } from 'uuid';
import { SessionIdName } from 'src/app/constants/strings';

@Injectable({
    providedIn: 'root'
})
export class SessionIdService {
    private readonly sessionId: string;

    constructor(private localStorage: LocalStoreManagerService) {
        const storedSessionId = this.localStorage.getData(SessionIdName);
        if (!storedSessionId) {
            this.sessionId = this.generateDashLessGuid();
            this.localStorage.saveSessionData(this.sessionId, SessionIdName);
        }
        else {
            this.sessionId = storedSessionId;
        }
    }

    getSessionId() {
        return this.sessionId;
    }

    private generateDashLessGuid(): string {
        const newGuid: string = uuidv4().toString();
        const newGuidWithDashesRemoved = newGuid.split('-').join('');
        return newGuidWithDashesRemoved;
    }
}

